import { type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { StorageService } from './storage.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const storageService = inject(StorageService);
  const token = storageService.getToken();
  const isApiUrl = req.url.startsWith(environment.apiUrl);

  if (token != null && isApiUrl) {
    const cloned = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
    return next(cloned);
  }

  return next(req);
}
